<template>
    <div id="store-section-section" class="pt-7 pb-7 mt-7 bg-parallax" :style="bannerStyle">
        <div class="container">
            <div class="text-white text-center">
                <h2 class="display-3 text-white montserrat-bold text-uppercase mb-3"><span class="text-danger inline">Download</span> our latest App</h2>
            </div>
            <div class="text-center">
                <a :href="links.appStore" class=" store-link">
                    <div class="icon">
                        <i class="fab fa-apple"></i>
                    </div>
                    <div class="text">
                        <div class="mb--2">Available on</div>
                        <div class="store">App Store</div>
                    </div>
                </a>
                <a :href="links.playStore" class="store-link">
                    <div class="icon">
                        <i class="fab fa-google-play"></i>
                    </div>
                    <div class="text">
                        <div class="mb--2">Available on</div>
                        <div class="store">Play Store</div>
                    </div>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import { default as config } from "@src/config";
import { resource } from "@utils/network";

export default {
    name: "InnovativeFeaturesSection",
    computed: {
        bannerStyle() {
            return `background-image:url('${ resource("images/store-section-bg.png") }')`;
        }
    },

    data: () => ({
        links: {
            appStore: config.APP_STORE_LINK,
            playStore: config.PLAY_STORE_LINK,
        }
    })
}
</script>

<style scoped lang="css">
    .store-link {
        text-align: left;
        display: inline-block;
        border: 1px solid white;
        color: white;
        background-color: transparent;
        transition: 0.3s ease-in-out;
        padding: 15px 25px;
        width: 250px;
        margin: 40px 20px 0px 20px;
    }
    .store-link:hover {
        border: 1px solid #ffbc2d !important;
        color: white;
        background-color: #ffbc2d !important;
    }
    .store-link .icon {
        display: inline-block;
        
    }
    .store-link .text {
        display: inline-block;
    }
    .store-link .text .store {
        font-size: 1.7275rem;
        font-weight: 600;
        line-height: 1.5;
    }
</style>